import BaseComponent from "../global/base-component";
import { SearchResultsProvider } from "./context/search-results-context";
import { SearchResultsComponent } from "./search-results-component";

export function SearchResultsFactory() {
    return (
        <BaseComponent>
            <SearchResultsProvider>
                <SearchResultsComponent />
            </SearchResultsProvider>
        </BaseComponent>
    );
}
